module.exports = __webpack_public_path__ + "img/step1.87da98ae.png";